import { render, staticRenderFns } from "./SeeTranslate.vue?vue&type=template&id=5eb9a4f9&scoped=true&"
import script from "./SeeTranslate.vue?vue&type=script&lang=js&"
export * from "./SeeTranslate.vue?vue&type=script&lang=js&"
import style0 from "./SeeTranslate.vue?vue&type=style&index=0&id=5eb9a4f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb9a4f9",
  null
  
)

export default component.exports